import axios from "axios";
import { Toast } from "antd-mobile";
import {
  getLoginUid,
  getSessionSecretKey,
  clearAuthStorage
} from "../utils/auth-storage";
import {
  applyRequestSign,
  sanitizeRequestParams,
  shouldSkipSign
} from "../utils/request-sign";

let baseURL = window.CONFIG_URL.baseURL;
let baseURL2 = window.CONFIG_URL2.baseURL;

const SIGN_ERROR_STATUS = [1006, 1007, 1008, 1009, 1010];

axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;

function handleAuthExpired() {
  clearAuthStorage();
  window.location.reload();
}

axios.interceptors.request.use(
  function(config) {
    const token =
      sessionStorage.getItem("loginMsg") &&
      JSON.parse(sessionStorage.getItem("loginMsg")).token;

    switch (config.urlType) {
      case "new":
        config.url = baseURL2 + config.url;
        break;
      default:
        config.url = baseURL + config.url;
    }

    if (config.urlType) {
      const accessToken = sessionStorage.getItem("pc-access-token");
      const webSession = sessionStorage.getItem("manager-web-session");
      config.headers["pc-access-token"] = accessToken;
      config.headers["manager-web-session"] = webSession;
      config.params = {
        ...config.params
      };

      const method = (config.method || "get").toLowerCase();
      if (
        (method === "post" || method === "put" || method === "patch") &&
        config.data !== undefined &&
        config.data !== null &&
        !(typeof FormData !== "undefined" && config.data instanceof FormData)
      ) {
        config.headers["Content-Type"] = "application/json;charset=UTF-8";
      }

      const sessionSecretKey = getSessionSecretKey();
      const loginUid = getLoginUid();
      const requestUrl = config.url || "";

      if (
        accessToken &&
        sessionSecretKey &&
        loginUid &&
        !shouldSkipSign(requestUrl)
      ) {
        const timestamp = String(Date.now());
        const signParams = sanitizeRequestParams(config.params);
        config.params = signParams;

        const { bodyStr, nonce, sign } = applyRequestSign({
          uid: loginUid,
          token: accessToken,
          sessionKeyBase64: sessionSecretKey,
          timestamp,
          params: signParams,
          data: config.data
        });

        if (
          config.data !== undefined &&
          config.data !== null &&
          typeof config.data === "object" &&
          !(typeof FormData !== "undefined" && config.data instanceof FormData) &&
          !(
            typeof URLSearchParams !== "undefined" &&
            config.data instanceof URLSearchParams
          )
        ) {
          config.data = bodyStr;
        }

        config.headers["X-Nonce"] = nonce;
        config.headers["X-Timestamp"] = timestamp;
        config.headers["X-Sign"] = sign;
      }
    } else {
      config.headers["token"] = token;
      config.params = {
        ...config.params
      };
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    Toast.hide();
    if (response.status == 200 && response.data) {
      const status = Number(response.data.status);
      if (response.data.status == -1001 || response.data.status == 403) {
        handleAuthExpired();
      } else if (SIGN_ERROR_STATUS.indexOf(status) !== -1) {
        Toast.info(response.data.message || "签名校验失败", 2);
        return response.data;
      } else {
        return response.data;
      }
    } else {
      return null;
    }
  },
  error => {
    console.log(error);
    Toast.hide();
    Toast.info("操作失败", 1);
    return Promise.reject(error);
  }
);

export default axios;
